import styled from 'styled-components';
import css from '@styled-system/css';

import { contentfulCustomerStorySnapshot } from 'types';
import Box from 'legacy/components/box';
import Text from 'legacy/components/text';

const SnapshotWrapper = styled(Box)(
  css({
    height: ['auto', null, null, null, 0],
    position: 'relative',
  })
);

const SnapshotBox = styled(Box)(
  css({
    position: ['relative', null, null, null, 'absolute'],
    left: 'unset',
    right: [0, null, null, null, '45.5rem'],
    maxWidth: ['100%', null, null, null, '20rem'],
    width: ['100%', null, null, null, '20vw'],
    mx: ['auto', null, null, null, 0],
    bg: 'gray100',
    borderRadius: 'extraLarge',
    p: '1.5rem',
  })
);

const SnapshotHeading = styled(Text)(
  css({
    mt: 3,
    mb: 0,
    fontWeight: 600,
    color: 'blue',
  })
);

const SnapshotText = styled(Text)(
  css({
    my: 0,
  })
);

const CompanySnapshot = ({ snapshot }) => {
  const { industry, size, location, payroll, solution } = snapshot;
  return (
    <SnapshotWrapper as="aside">
      <SnapshotBox>
        {!!industry?.length && (
          <>
            <SnapshotHeading>Industry</SnapshotHeading>
            <SnapshotText>{industry}</SnapshotText>
          </>
        )}
        {!!size && (
          <>
            <SnapshotHeading>Company Size</SnapshotHeading>
            <SnapshotText>{`${size} employees`}</SnapshotText>
          </>
        )}
        {!!location?.length && (
          <>
            <SnapshotHeading>Location</SnapshotHeading>
            <SnapshotText>{location}</SnapshotText>
          </>
        )}
        {!!payroll?.length && (
          <>
            <SnapshotHeading>Payroll</SnapshotHeading>
            <SnapshotText>{payroll}</SnapshotText>
          </>
        )}
        {!!solution?.length && (
          <>
            <SnapshotHeading>Solution</SnapshotHeading>
            <SnapshotText>{solution}</SnapshotText>
          </>
        )}
      </SnapshotBox>
    </SnapshotWrapper>
  );
};

CompanySnapshot.propTypes = {
  snapshot: contentfulCustomerStorySnapshot.isRequired,
};

export default CompanySnapshot;
